import React from "react";
import { Link } from "react-router-dom";
import { Image, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import inventronics from "./../../assets/inventronics.png";
import ledvance from "./../../assets/ledvance.png";
import powerIcon from "./../../assets/power.svg";
import "./header.css";
import { webConfig } from "../../config";

function Header({ active }) {
  let logoImage = inventronics;
  let logoClass = "App-logo-inventronics";

  if (webConfig.LEDVANCE === "true") {
    logoImage = ledvance;
    logoClass = "App-logo-ledvance";
  }

  return (
    <Row className="App-header m-0 border-bottom border-dark">
      <Row className="text-start">
        <Col className="col-2">
          <Link to="/">
            <Image src={logoImage} className={logoClass} />
          </Link>
        </Col>
        <Col className="col"></Col>
        <Col className="col-2 d-flex justify-content-end">
          {active ? (
            <Link to="/logout" className="btn btn-logout pt-2">
              <Image className="m-0" src={powerIcon} style={{ width: 30 }} />
              <span className="p-2">Logout</span>
            </Link>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </Row>
  );
}

export default Header;
